import * as R from 'ramda'
import { permissionType } from './types'

// 確保順序正確，assign 的值才會正確
const permissions = [
  permissionType.storeUserBasic,
  permissionType.cashierBasic,
  permissionType.monitorBasic,
  permissionType.createStore,
  permissionType.getStoreInfo,
  permissionType.updateStoreInfo,
  permissionType.deleteStore,
  permissionType.getStatistics,
  permissionType.getOrder,
  permissionType.createOrder,
  permissionType.updateOrderContent,
  permissionType.updateOrderProcessStatus,
  permissionType.updateOrderPaymentStatus,
  permissionType.updateOrderReceiptPrintedStatus,
  permissionType.refundOrder,
  permissionType.deleteOrder,
  permissionType.getStoreMenuDraft,
  permissionType.createStoreMenuDraft,
  permissionType.updateStoreMenuDraft,
  permissionType.deleteStoreMenuDraft,
  permissionType.releaseStoreMenu,
  permissionType.getUserPermission,
  permissionType.updateUserPermission,
  permissionType.updateAdminPermission
]

export const systemPermissions = permissions.reduce((ps, label, index) => R.assoc(label, 1 << index, ps), {})

// 前端會按照這個順序列出畫面上的權限
export const userPermissionSettingList = [
  permissionType.getStoreInfo,
  permissionType.updateStoreInfo,
  permissionType.createStore,
  permissionType.getStatistics,
  permissionType.getOrder,
  permissionType.updateOrderProcessStatus,
  permissionType.updateOrderReceiptPrintedStatus,
  permissionType.updateOrderPaymentStatus,
  permissionType.refundOrder,
  permissionType.deleteOrder,
  permissionType.getStoreMenuDraft,
  permissionType.createStoreMenuDraft,
  permissionType.updateStoreMenuDraft,
  permissionType.deleteStoreMenuDraft,
  permissionType.releaseStoreMenu,
  permissionType.cashierBasic,
  permissionType.getUserPermission,
  permissionType.updateUserPermission
]
